import { SKELETON_BLOCK, skeletonSlots } from '@/shared/ui/components/basic/data-state/skeletons/skeleton-primitives';

/**
 * The plan tab's loading state, shaped like the tab itself.
 *
 * Mirrors the real layout so the screen settles rather than reflowing: a strip
 * bar, two meter cards, three invoice rows.
 *
 * @returns The skeleton.
 */
export function PlanTabSkeleton() {
  return (
    <div className="flex flex-col gap-(--space-5)" data-testid="plan-tab-skeleton" aria-busy>
      <div className={SKELETON_BLOCK} style={{ height: 'var(--space-13)' }} />
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: 'var(--space-3)',
      }}>
        {skeletonSlots(2).map((slot) => (
          <div key={slot} className={SKELETON_BLOCK} style={{ height: 'var(--space-32)' }} />
        ))}
      </div>
      <div className="flex flex-col gap-(--space-2)">
        {skeletonSlots(3).map((slot) => (
          <div key={slot} className={SKELETON_BLOCK} style={{ height: 'var(--space-8)' }} />
        ))}
      </div>
    </div>
  );
}
